// GDPR-friendly analytics loader + consent gate
import { getConfig } from "./runtimeConfig";
const CONSENT_KEY = "verihandi_consent";

export function getConsent() {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    if (v === "accepted" || v === "rejected") return v;
  } catch { /* ignore */ }
  return null;
}

export function setConsent(v) {
  try { localStorage.setItem(CONSENT_KEY, v); } catch { /* ignore */ }
  window.dispatchEvent(new Event("consent-changed"));
  if (v === "accepted") loadAnalytics();
  else removeAnalytics();
}

let loaded = false;

export function loadAnalytics() {
  const cfg = getConfig();
  const gaId = cfg.ga_id;
  const gtmId = cfg.gtm_id;
  if (!gaId && !gtmId) return;
  if (getConsent() !== "accepted") return;
  if (loaded) return;
  loaded = true;

  if (gtmId) {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.id = "verihandi-gtm";
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", gtmId);
    // GTM <noscript> iframe fallback — required by Google for JS-disabled UAs.
    // Injected dynamically so it only appears when a GTM ID is configured AND consent is granted.
    if (!document.getElementById("verihandi-gtm-ns")) {
      const ns = document.createElement("noscript");
      ns.id = "verihandi-gtm-ns";
      ns.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden" title="gtm"></iframe>`;
      document.body.insertBefore(ns, document.body.firstChild);
    }
  }
  if (gaId) {
    const script = document.createElement("script");
    script.async = true;
    script.id = "verihandi-ga";
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    // No auto page_view — we'll send them manually on route change
    window.gtag("config", gaId, { send_page_view: false, anonymize_ip: true });
  }
}

export function removeAnalytics() {
  loaded = false;
  ["verihandi-ga", "verihandi-gtm", "verihandi-gtm-ns"].forEach(id => {
    const el = document.getElementById(id);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  });
  // clear any _ga* and _gid cookies
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (name.startsWith("_ga") || name === "_gid" || name.startsWith("_gat")) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
      document.cookie = `${name}=; Max-Age=0; path=/`;
    }
  });
  window.gtag = undefined;
}

export function trackPageView(path, title) {
  try {
    const gaId = getConfig().ga_id;
    if (window.gtag && gaId) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_title: title || document.title,
        page_location: window.location.href,
      });
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: "page_view", page_path: path });
    }
  } catch { /* ignore */ }
}

export function trackEvent(name, params = {}) {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.dataLayer) window.dataLayer.push({ event: name, ...params });
  } catch { /* ignore */ }
}

export function analyticsAvailable() {
  const c = getConfig();
  return !!(c.ga_id || c.gtm_id);
}
